import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, LayoutDashboardIcon, InfoIcon, PackageIcon, AlertTriangleIcon, SettingsIcon, ClipboardListIcon, TrendingUpIcon } from 'lucide-react';
import { GeneralInfo } from '../components/GeneralInfo';
import { StockOverview } from '../components/StockOverview';
import { StockDesigns } from '../components/StockDesigns';
import { AlertsPanel } from '../components/AlertsPanel';
import { InventoryPanel } from '../components/InventoryPanel';
import { StockForecastPanel } from '../components/StockForecastPanel';
const menuItems = [{
  id: 'overview',
  label: 'Overview',
  icon: LayoutDashboardIcon
}, {
  id: 'inventory',
  label: 'Inventario',
  icon: ClipboardListIcon
}, {
  id: 'stock',
  label: 'Machine Stock',
  icon: PackageIcon
}, {
  id: 'alerts',
  label: 'Alerts',
  icon: AlertTriangleIcon
}, {
  id: 'forecast',
  label: 'Stock Forecast',
  icon: TrendingUpIcon
}, {
  id: 'details',
  label: 'Details',
  icon: InfoIcon
}, {
  id: 'settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function WarehouseDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const warehouseData = {
    code: 'IU1',
    name: 'Pierce - San Antonio',
    organizationId: '9946',
    country: 'United States',
    region: 'Aisco AMERICA',
    address: '6203 Woodlake Center TEXAS San Antonio United States',
    zipCode: '78244',
    coordinates: '29.485804, -98.360062'
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-688">
      <div className="bg-white border-b border-gray-200" data-id="element-689">
        <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-690">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors mb-4" data-id="element-691">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-692" />
            <span className="font-medium" data-id="element-693">Back to Warehouses</span>
          </button>
          <div className="flex items-center gap-4" data-id="element-694">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/30" data-id="element-695">
              <span className="text-xl font-bold text-white" data-id="element-696">
                {warehouseData.code}
              </span>
            </div>
            <div data-id="element-697">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-698">
                {warehouseData.name}
              </h1>
              <p className="text-gray-600 text-sm mt-1" data-id="element-699">
                {warehouseData.region}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 mt-6 border-b border-gray-200" data-id="element-700">
            {menuItems.map(item => {
            const Icon = item.icon;
            return <button key={item.id} onClick={() => setActiveTab(item.id)} className={`flex items-center gap-2 px-5 py-3 font-medium transition-all relative ${activeTab === item.id ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-701">
                  <Icon className="w-5 h-5" data-id="element-702" />
                  <span data-id="element-703">{item.label}</span>
                  {activeTab === item.id && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" data-id="element-704"></div>}
                </button>;
          })}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-705">
        {activeTab === 'overview' && <StockOverview data-id="element-706" />}
        {activeTab === 'stock' && <StockDesigns data-id="element-707" />}
        {activeTab === 'inventory' && <InventoryPanel data-id="element-708" />}
        {activeTab === 'alerts' && <AlertsPanel data-id="element-709" />}
        {activeTab === 'forecast' && <StockForecastPanel data-id="element-710" />}
        {activeTab === 'details' && <GeneralInfo data={warehouseData} data-id="element-711" />}
      </div>
    </div>;
}